<template> 
<div style="overflow-x:hidden;height:100vh;" class="main_page">
  <div v-if="type=='dash'">
      <div v-if="false">
          <MainNavbar />
      </div>
       <div :class=' isdisplay ? "nav-bar-minimized":"nav-bar"' class="transition-controller">
          <DashNavbar/>
      </div>
      <aside>
            <SideNavBar class='side-nav' :isdisplay="isdisplay"/>
            </aside>
             <div class="content-wrapper">
      
            <AppMain :class=' isdisplay ? "topiccard-minimized":"topiccard"' class="transition-controller" style="margin-top:0px;"/>
         
      </div>
</div>
<div v-if="type=='main'">
      <div>
          <MainNavbar/>
      </div>
         <div  >
            <AppMain/>
          </div>
</div>
<!-- <Footer/> -->
    </div>
</template>
<script>
import DashNavbar from './../components/Navbar/navbarHeader.vue'
// import Footer from './../components/Footer/footer.vue'
import MainNavbar from './../components/Navbar/navbarold'
import SideNavBar from './../components/SideNav/adminsidenav'
import AppMain from './AppMain'
export default {
    components:{DashNavbar,MainNavbar,SideNavBar,AppMain},
    props:{
      type:String
    },
    data(){
        return {
          isdisplay:false,
        }
    },
    mounted(){
      
    window.Fire.$on('hide-or-unhide-sidenav',()=>{
      this.isdisplay=!this.isdisplay
    })
    }
}
</script>
<style scoped>
.main_page{
  background-color: rgba(219, 217, 217, 0.219);
}
.content-wrapper{
  margin-top:100px;
  margin-right: 10px;
  margin-left: 10px;
}
.transition-controller{
   transition: margin 0.28s;
}
#side-nav.togled{
    display: block;
}
#side-nav{
  width: 15%;
}
#side-nav-minimized{
  width:50px;
}
.topiccard{
  margin-left:12%;
}
.nav-bar{
  margin-left: 0px;
}
@media screen and (max-width: 767px) {
  #side-nav{
    position: absolute;
    left:0;
    bottom:0px;
    top:0px;
    z-index:100;
 transition: padding 0.28s;
 transition-timing-function: ease;
}
.content-wrapper{
    margin-left:0;
    margin-right: 0;
    margin-top:60px;
  }
#side-nav{
  display: none;
  width:100% !important;
  background-color:rgba(0.5,0.5,0.5,0.5);
}
#side-nav-minimized{
 display: none;
}
  .topiccard{
  margin-left:0px;
}
.nav-bar{
  margin-left:0;
}
.topiccard-minimized{
  box-sizing: border-box;
  margin-left:0px;
}
.nav-bar-minimized{
   box-sizing: border-box;
  margin-left:0px;
}
.nav{
  display: none;
}
.tab{
  display: none;
}
.topiccard{
  box-sizing: border-box;
  overflow-x:hidden;
}
.nav-bar{
  box-sizing: border-box;
  overflow-x:hidden;
}
.topiccard-minimized{
   box-sizing: border-box;
  overflow-x:hidden;
}
.nav-bar-minimized{
    box-sizing: border-box;
  overflow-x:hidden;
}
}
@media screen and (max-width: 991px) {
  #side-nav{
    position: absolute;
    left:0;
    bottom:0px;
    top:0px;
    z-index:100;
 transition: padding 0.28s;
 transition-timing-function: ease;
}
.content-wrapper{
    margin-left:0;
    margin-top:60px;
  }
#side-nav{
  display: none;
  width:100% !important;
  background-color:rgba(0.5,0.5,0.5,0.5);
}
#side-nav-minimized{
 display: none;
}
  .topiccard{
  margin-left:0px;
}
.nav-bar{
  margin-left:0;
}
.topiccard-minimized{
  box-sizing: border-box;
  margin-left:0px;
}
.nav-bar-minimized{
   box-sizing: border-box;
  margin-left:0px;
}
.nav{
  display: none;
}
.tab{
  display: none;
}
.topiccard{
  box-sizing: border-box;
  overflow-x:hidden;
}
.nav-bar{
  box-sizing: border-box;
  overflow-x:hidden;
}
.topiccard-minimized{
   box-sizing: border-box;
  overflow-x:hidden;
}
.nav-bar-minimized{
    box-sizing: border-box;
  overflow-x:hidden;
}
}
</style>